<template>
  <v-dialog max-width="500px" v-model="dialog" @keydown.enter.prevent="save">
    <v-card>
      <v-card-title>
        <span class="headline">Trigger Group</span>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6" md="6">
            <r-trigger-scope :items="scopes" :model.sync="model.scope"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="12" sm="12"></v-col>
          <v-col cols="12" md="12" sm="12">
            <v-menu :absolute="false"
                    :close-on-click="true"
                    :close-on-content-click="true"
                    :offset-y="true">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" small color="primary">Add Trigger
                  <v-icon class="ml-2" x-small>mdi-text-box</v-icon>
                </v-btn>
              </template>
              <v-list v-for="(kind,i) in types" :key="i" dense class="pa-0">
                <v-list-item @click="row_create(kind)" dense>
                  <v-list-item-title v-text="kind.name"/>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="12" md="12" sm="12">
            <v-chip v-for="(trigger,i) in items"
                    :key="i"
                    class="ma-1"
                    :color="trigger.visible ? 'green':'blue darken-1'"
                    :outlined="!trigger.visible"
                    :text-color="trigger.visible ? 'white':'blue'"
                    close
                    @click="row_update(trigger)"
                    @click:close="row_remove(trigger)"
            >
              {{ trigger.kind.name }}
            </v-chip>
          </v-col>
          <v-col cols="12" md="12" sm="12">
            <v-divider class="mb-2"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>

    <r-trigger-generic ref="trigger_1"/>
    <r-trigger-item ref="trigger_2"/>
    <r-trigger-quest ref="trigger_3"/>
    <r-trigger-talk ref="trigger_4"/>
    <r-trigger-item-group ref="trigger_5"/>
    <r-trigger-order ref="trigger_6"/>
    <r-trigger-tutorial ref="trigger_7"/>
    <r-trigger-product ref="trigger_8"/>
    <r-trigger-currency ref="trigger_9"/>
    <r-trigger-trader ref="trigger_11"/>
    <r-trigger-ship ref="trigger_12"/>
    <r-trigger-johan ref="trigger_13"/>
    <r-trigger-smart-offer ref="trigger_14"/>
  </v-dialog>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {TriggerKind} from "@/modules/redactor/models/trigger/core/TriggerKind";
import {TriggerGroup, TriggerGroupScope} from "@/modules/redactor/models/trigger/TriggerGroup";

import RTriggerScope from "@/modules/redactor/views/trigger/r-trigger-scope";
import RTriggerGeneric from "@/modules/redactor/views/trigger/r-trigger-generic";
import RTriggerItem from "@/modules/redactor/views/trigger/r-trigger-item";
import RTriggerQuest from "@/modules/redactor/views/trigger/r-trigger-quest";
import RTriggerTalk from "@/modules/redactor/views/trigger/r-trigger-talk";
import RTriggerItemGroup from "@/modules/redactor/views/trigger/r-trigger-item-group";
import RTriggerOrder from "@/modules/redactor/views/trigger/r-trigger-order";
import RTriggerTutorial from "@/modules/redactor/views/trigger/r-trigger-tutorial";
import RTriggerProduct from "@/modules/redactor/views/trigger/r-trigger-product";
import RTriggerCurrency from "@/modules/redactor/views/trigger/r-trigger-currency";
import RTriggerShip from "@/modules/redactor/views/trigger/r-trigger-ship";
import RTriggerTrader from "@/modules/redactor/views/trigger/r-trigger-trader";
import RTriggerJohan from "@/modules/redactor/views/trigger/r-trigger-johan";
import RTriggerSmartOffer from "@/modules/redactor/views/trigger/r-trigger-smart-offer.vue";

export default {
  name: "r-trigger-group",
  components: {
    RTriggerSmartOffer,
    RTriggerJohan,
    RTriggerTrader,
    RTriggerShip,
    RTriggerCurrency,
    RTriggerProduct,
    RTriggerTutorial,
    RTriggerOrder,
    RTriggerItemGroup,
    RTriggerTalk,
    RTriggerQuest,
    RTriggerItem,
    RTriggerGeneric,
    RTriggerScope
  },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: VueTypes.objectOf(TriggerGroup),
    rules: ViewRules.READONLY,
  }),
  computed: {
    scopes() {
      return TriggerGroupScope.getValues();
    },
    types() {
      return TriggerKind.getValues().filter(v => !TriggerKind.TRIGGER_GROUP.equal(v));
    },
    items() {
      return this.model.items;
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new TriggerGroup();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },

    row_create(kind) {
      this.$refs['trigger_' + kind.id].show(ViewRules.CREATE)
          .then((data) => {
            this.items.push(data);
          }).catch(() => {
      });
    },
    row_update(trigger) {
      this.$refs['trigger_' + trigger.kind.id].show(ViewRules.UPDATE, trigger.clone())
          .then((data) => {
            const index = this.items.indexOf(trigger);
            this.items.splice(index, 1, data);
          }).catch(() => {
      });
    },
    row_remove(trigger) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.items.indexOf(trigger);
        this.items.splice(index, 1);
      });
    }
  }
}
</script>

<style lang="css" scoped>
.fill-width {
  width: 100%;
}
</style>